import { Modal } from 'flowbite-react';
import { HiOutlineExclamationCircle } from 'react-icons/hi';

export default function PopUpDelete({
  onConfirm,
  onClose,
  disabled = true,
  anotherText = (
    <h3 className="mb-5 text-lg font-normal text-font-500 dark:text-gray-400">
      Tem certeza que deseja deletar esse campo?
    </h3>
  )
}) {
  return (
    <div>
      <Modal show={true} size="md" onClose={() => onClose()} popup>
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
            {anotherText}
            <div className="flex justify-center">
              <button
                disabled={disabled}
                className={`w-full text-white ${disabled ? 'bg-gray' : 'bg-locavibe'}`}
                onClick={() => { onConfirm(); }}>
                {"Confirmar"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
